<template>
  <main class="flex-initial container relative bg-gray-100">
    <button @click="sendToFigma" class=" bg-indigo-600 p-2 mr-2 rounded text-white hover:bg-indigo-700">Export to Figma</button>
    <div id="canvas" :style="cssVars"></div>
    <div>
      <input type="range" id="val1" name="val1" min="1" max="20" step="1" v-model="val1">
      <label for="val1">(1) a Constant {{ val1 }}</label>
    </div>
    <div>
      <input type="range" id="val2" name="val2" min="1" max="20" step="1" v-model="val2">
      <label for="val2">(2) b Constant {{ val2 }}</label>
    </div>
    <div>
      <input type="range" id="val3" name="val3" min="0" max="2" step="0.01" v-model="val3">
      <label for="val3">(3) Phase Angle {{ val3 }}</label>
    </div>
    <div>
      <input type="range" id="val4" name="val4" min="1" :max="canvasWidth * 2" step="1" v-model="val4">
      <label for="val4">(4) X Amplitude {{ val4 }}</label>
    </div>
    <div>
      <input type="range" id="val5" name="val5" min="1" :max="canvasHeight * 2" step="1" v-model="val5">
      <label for="val5">(5) Y Amplitude {{ val5 }}</label>
    </div>
    <div>
      <input type="range" id="val6" name="val6" min="1" max="100" step="1" v-model="val6">
      <label for="val6">(6) t {{ val6 }}</label>
    </div>
    <div>
      <input type="range" id="val7" name="val7" min="0.025" max="2.073" step="0.001" v-model="val7">
      <label for="val7">(7) inc_t {{ val7 }}</label>
    </div>
    <div>
      <input type="range" id="val8" name="val8" min="1" max="10000" step="1" v-model="val8">
      <label for="val8">(8) frames {{ val8 }}</label>
    </div>
  </main>
</template>

<script>
import P5 from "p5";

export default {
  components: {

  },

  props: ["selectedNodeChanged"],

  data() {
    return {
      p5: null,
      canvasWidth: 600,
      canvasHeight: 600,
      val1: 3,
      val2: 6,
      val3: 0.1,
      val4: 600,
      val5: 600,
      val6: 1,
      val7: 0.025,
      val8: 400
    };
  },

  watch: {
    val1: function(newVal, oldVal) {
      this.val1 = newVal
      this.p5.dataChanged(newVal);
    },
    val2: function(newVal, oldVal) {
      this.val2 = newVal
      this.p5.dataChanged(newVal);
    },
    val3: function(newVal, oldVal) {
      this.val3 = newVal
      this.p5.dataChanged(newVal);
    },
    val4: function(newVal, oldVal) {
      this.val4 = newVal
      this.p5.dataChanged(newVal);
    },
    val5: function(newVal, oldVal) {
      this.val5 = newVal
      this.p5.dataChanged(newVal);
    },
    val6: function(newVal, oldVal) {
      this.val6 = newVal
      this.p5.dataChanged(newVal);
    },
    val7: function(newVal, oldVal) {
      this.val7 = newVal
      this.p5.dataChanged(newVal);
    },
    val8: function(newVal, oldVal) {
      this.val8 = newVal
      this.p5.dataChanged(newVal);
    }
  },

  methods: {
    async convertCanvas(){
      return new Promise((accept) => {
        let canvas = document.getElementById('defaultCanvas0');

        let blob = canvas.toBlob(async(blob)=>{
          let arrayBuffer = await blob.arrayBuffer()
          let uint8Array = new Uint8Array(arrayBuffer);
          return accept(uint8Array)
        }, 'image/png', 1);
      })
    },
    async sendToFigma(){
      let msg = {}
      msg.w = this.canvasWidth
      msg.h = this.canvasWidth
      msg.uint8Array = await this.convertCanvas()

      parent.postMessage(msg, '*');
    }
  },

  mounted() {
    
    const script = (p5) => {
      this.p5 = p5;
      let here = this


      /* Scale image and reduce by 10 pixels to remove from edge of screen */
      let AX = here.val4 / 2;
      let BX = here.val5 / 2;

      let a = here.val1;
      let b = here.val2;

      let m = here.val1;
      let n = here.val2;

      let delta = here.val3 * p5.PI

      let frames = here.val8;
      let x, y;
      let theta = Number(here.val6);
      let inc_t = Number(here.val7);

      let previous, current;

      p5.setup = () => {
        p5.createCanvas(here.canvasWidth,here.canvasHeight);
        // p5.background(255);
        p5.noLoop()
      }

      p5.draw= () => {
        p5.clear()
        // p5.background(255);
        
        for (let i = 0; i < frames; i++) {

          // Lissajous curve https://en.wikipedia.org/wiki/Lissajous_curve
          x = AX * p5.sin(a * theta + delta) + here.canvasWidth/2 ;
          y = BX * p5.sin(b * theta) + here.canvasHeight/2;

          // // Rhodonea curve https://en.wikipedia.org/wiki/Rose_(mathematics)
          // x = AX * p5.cos((m/n)*theta)*p5.cos(theta) + here.canvasWidth/2;
          // y = AX * p5.cos((m/n)*theta)*p5.sin(theta) + here.canvasHeight/2;

          if(i == 0){ // Fixing bug with weird line
            previous = p5.createVector(x, y);
            current = p5.createVector(x, y);
          }

          p5.stroke(x, 200, 200);
          p5.strokeWeight(1);
          p5.line(previous.x, previous.y, current.x, current.y);

          current.x = previous.x;
          current.y = previous.y;
          previous.x = x;
          previous.y = y;
        
          // p5.fill(1, 1, 1);
          // p5.ellipse(x, y, 5, 5);

          // p5.stroke(50, 20, 200)
          // p5.strokeWeight(1);
          // p5.line(x, y, x+30, y);

          // p5.stroke(x, 20, 200)
          // p5.strokeWeight(1);
          // p5.line(x, y, x, y+30);

          // p5.fill(x, 20, 200);
          // p5.rect(x, y, 10, 20); // x, y, w

          theta += inc_t;
        }
      }


      p5.dataChanged = function(val) {
        theta = Number(here.val6);
        inc_t = Number(here.val7);
        
        AX = here.val4 / 2;
        BX = here.val5 / 2;

        a = here.val1;
        b = here.val2;

        m = here.val1;
        n = here.val2;

        frames = here.val8;


        delta = here.val3 * p5.PI

        p5.draw()
      };
            
    };

    // Attach the canvas to the div
    const p5canvas = new P5(script, "canvas");
  },
  computed: {
    cssVars() {
      return {
        '--canvasWidth': this.canvasWidth + 'px',
        '--canvasHeight': this.canvasHeight + 'px'
      }
    }
  }
};
</script>

<style scoped>
  #canvas{
    padding: 0;
    margin: auto;
    display: block;
    width: var(--canvasWidth);
    height: var(--canvasHeight);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    filter: drop-shadow(0 10px 8px rgb(0 0 0 / 0.02)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.02));
  }
</style>
